import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../assets/LogoWhite.png';

const Header = () => {
  const location = useLocation();

  const scrollToForm = () => {
    if (location.pathname === '/') {
      const formElement = document.getElementById('diagnostic-form');
      if (formElement) {
        formElement.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Si no estamos en home, navegar a home y luego hacer scroll
      window.location.href = '/#diagnostic-form';
    }
  };

  return (
    <header className="bg-[#007ee5] shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo con carro sonriente */}
          <button onClick={scrollToForm} className="flex items-center hover:opacity-80 transition-opacity duration-200">
            <div className="flex items-center justify-center py-2">
              {/* Icono del carro sonriente */}
              <img src={Logo} alt="Logo" className="h-8 lg:h-14 mx-auto" />
            
            </div>
          </button>

          {/* Barra de búsqueda */}
          <div className="flex-1 max-w-md mx-8">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                {/* Icono de búsqueda con gradiente y estrellas */}
                <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none">
                  <defs>
                    <linearGradient id="searchGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#14b8a6" />
                      <stop offset="100%" stopColor="#8b5cf6" />
                    </linearGradient>
                  </defs>
                  <path 
                    stroke="url(#searchGradient)" 
                    strokeWidth={2} 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                  {/* Estrellas */}
                  <circle cx="18" cy="6" r="1" fill="#fbbf24" />
                  <circle cx="20" cy="4" r="0.5" fill="#60a5fa" />
                </svg>
              </div>
              <input
                type="text"
                placeholder="Search Dash AI"
                className="w-full pl-10 pr-4 py-2 text-gray-900 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
          </div>

          {/* Enlaces de navegación */}
          <nav className="hidden lg:flex space-x-6">
            <Link 
              to="/" 
              className="text-white hover:text-blue-200 px-3 py-2 text-sm font-medium transition-colors duration-200"
            >
              New Cars for Sale
            </Link>
            <Link 
              to="/used" 
              className="text-white hover:text-blue-200 px-3 py-2 text-sm font-medium transition-colors duration-200"
            >
              Used Cars for Sale
            </Link>
            <Link 
              to="/value" 
              className="text-white hover:text-blue-200 px-3 py-2 text-sm font-medium transition-colors duration-200"
            >
              My Car Value
            </Link>
            <Link 
              to="/reviews" 
              className="text-white hover:text-blue-200 px-3 py-2 text-sm font-medium transition-colors duration-200"
            >
              Car Reviews
            </Link>
          </nav>

          {/* Iconos de usuario */}
          <div className="flex items-center space-x-4">
            {/* Icono de notificaciones (campana) */}
            <button className="text-white hover:text-blue-200 transition-colors duration-200">
              <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
              </svg>
            </button>
            
            {/* Icono de usuario con dropdown */}
            <div className="relative">
              <button className="flex items-center text-white hover:text-blue-200 transition-colors duration-200">
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <svg className="h-4 w-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
